// Centralized feature flags.
//
// Default posture is OFF unless explicitly enabled.

const truthy = (value: unknown) => {
  const v = String(value ?? '').trim().toLowerCase();
  return v === '1' || v === 'true' || v === 'yes' || v === 'on';
};

export const FAF_ENABLED: boolean =
  // Keep existing tests stable unless explicitly disabled.
  (import.meta.env.MODE === 'test') || truthy((import.meta as any).env?.VITE_ENABLE_FAF);
